import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';


//redux

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { adminLogin } from '../../lib/Apis';
import { useMutation } from '@tanstack/react-query';
//import images

const Login = (props) => {
    const [userLogin, setUserLogin] = useState([]);
    const [showPassword, setShowPassword] = useState(false);


    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            username: userLogin.username || '',
            password: userLogin.password || '',
        },

        validationSchema: Yup.object({
            username: Yup.string()
                .min(3, 'Username must be at least 3 characters')
                .required('Username is required'),

            password: Yup.string()
                .required("Please Enter Your Password"),
        }),

        onSubmit: (values) => {
            loginMutate(values); // triggers the mutation
        }

    });

    const {
        mutate: loginMutate,
        isLoading,
        isError,
        error,
        data: loginData,
    } = useMutation({
        mutationFn: adminLogin,
        onSuccess: (data) => {
            sessionStorage.setItem('token', data?.token)
            props.router.navigate("/categories"); 
        },
        onError: (err) => {
        },
    });
    


    const signIn = type => {

    };

    //handleTwitterLoginResponse
    // const twitterResponse = e => {}

    //for facebook and google authentication
    const socialResponse = type => {
        signIn(type);
    };




    document.title = "SignIn | Brew Chew Menu Admin Panel";
    return (
        <React.Fragment>

            <div className="auth-page-content">
                <Container>

                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Welcome Admin !</h5>
                                        <p className="text-muted">Sign in to continue.</p>
                                    </div>
                                    {/* {error && error ? (<Alert color="danger"> {error} </Alert>) : null} */}
                                    <div className="p-2 mt-4">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            action="#">

                                            <div className="mb-3">
                                                <Label htmlFor="username" className="form-label">Username</Label>
                                                <Input
                                                    name="username"
                                                    className="form-control"
                                                    placeholder="Enter username"
                                                    type="text"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.username || ""}
                                                    invalid={
                                                        validation.touched.username && validation.errors.username ? true : false
                                                    }
                                                />
                                                {validation.touched.username && validation.errors.username ? (
                                                    <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                                                ) : null}
                                            </div>


                                            <div className="mb-3">
                                               
                                                <Label className="form-label" htmlFor="password-input">Password</Label>
                                                <div className="position-relative auth-pass-inputgroup mb-3">
                                                    <Input
                                                        name="password"
                                                        value={validation.values.password || ""}
                                                        type={showPassword ? "text" : "password"}
                                                        className="form-control pe-5"
                                                        placeholder="Enter Password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        invalid={
                                                            validation.touched.password && validation.errors.password ? true : false
                                                        }
                                                    />
                                                    {validation.touched.password && validation.errors.password ? (
                                                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                    ) : null}
                                                    <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none" onClick={() => setShowPassword(!showPassword)} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                                </div>
                                            </div>
                                            {isError && (
                                                <div className="alert alert-danger mt-3">
                                                    {error || "Something went wrong"}
                                                </div>
                                            )}


                                           

                                            <div className="mt-4">
                                                <Button color="success" className="btn btn-success w-100" type="submit" disabled={isLoading}>
                                                    {isLoading ? <Spinner size="sm" className='me-2'>Loading...</Spinner> : 'Sign In'}
                                                </Button>

                                            </div>

                                            
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                           

                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    );
};

export default withRouter(Login);